import { envConfigs } from '../../../envConfigs';
import { handleServiceCall } from '../../app/util/fetch-utils';

export const getRecommendations = (userName, interfaceLanguage, targetLanguage, token) => {
  const lpsUri =
    envConfigs.lpsApiHost +
    '/api/activities/recommendation?full_name=' +
    encodeURIComponent(userName) +
    '&locale=' +
    interfaceLanguage +
    '&targetLanguage=' +
    targetLanguage;
  return fetch(lpsUri, {
    headers: {
      Authorization: 'Bearer ' + token,
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Accept: 'application/json'
    }
  }).then((response) => {
    return handleServiceCall(response);
  });
};

export const saveTargetLanguage = (userId, targetLanguageCode, token) => {
  if (!userId) {
    console.log('saveTargetLanguage called with no gui:', targetLanguageCode, token);
  }
  const lpsUri = envConfigs.lpsApiHost + '/api/user/reset_language_and_level';
  const putObject = { guid: userId, language: targetLanguageCode };
  const putString = JSON.stringify(putObject);
  return fetch(lpsUri, {
    method: 'PUT',
    body: putString,
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache'
    }
  }).then((response) => {
    return handleServiceCall(response);
  });
};

export const skipAssessment = (activityId, token) => {
  const lpsUri = envConfigs.lpsApiHost + '/api/activity_results/skip_assessment';
  const body = JSON.stringify({ activity_id: activityId });
  const method = 'POST';
  const headers = {
    Accept: 'application/json',
    Authorization: 'Bearer ' + token,
    'Content-Type': 'application/json;charset=UTF-8',
    'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
    Pragma: 'no-cache'
  };
  return fetch(lpsUri, {method, body, headers}).then((response) => {
    return handleServiceCall(response);
  });
};



// WEBPACK FOOTER //
// ./src/modules/launchpad/services/launchpad-api.js